import * as React from 'react';
import cx from 'classnames';
import style from './Files.css';

import Introduction from "./pdf/Introduction.pdf";
import Ethnography from "./pdf/An Ethnography of Decentralised Information Infrastructure.pdf";
import TechnoReflexivity from "./pdf/Techno-reflexivity A creative methodology for software developer un-bias.pdf";
import AlgorithmsAsPolicy from "./pdf/Algorithms as Policy.pdf";
import AutomatingOstrom from "./pdf/Automating Ostrom for Effective DAO Management.pdf";
import DeterringAdversarial from "./pdf/Deterring Adversarial Behavior at Scale in Gitcoin Grants.pdf";
import EngineeringEthics from "./pdf/Engineering Ethics in Web3.pdf";
import ExploringDAOs from "./pdf/Exploring DAOs as a New Kind of Institution.pdf";
import DecentralisedInfrastructure from "./pdf/The Possibilities of Ad Hoc Decentralised Digital Infrastructure.pdf";
import CAG from "./pdf/Towards Computer-Aided Governance of Gitcoin Grants.pdf";
import NetworkFormationGames from "./pdf/Network Formation Games.pdf";
import Conclusion from "./pdf/Conclusion.pdf";

import CeramicEcosystemReport from "./pdf/CeramicEcosystemMappingReport.pdf";
import ArbitrumExpert from "./pdf/ArbitrumExpertServiceProviderNetworkProgramDevelopment.pdf";

const File = (props) => (
    <li><a className={style.articleLink} target="_blank" href={props.file}>
        {props.title}
    </a></li>
);

export class Files extends React.Component {
    render() {
        return (
            <div className={style.root}>
                <header className={style.header}>
                    <div className="container">
                        <h1 className={cx(style.title, 'wow', 'fadeInUp')}></h1>
                        <p className={cx(style.text, 'wow', 'fadeInUp')} data-wow-delay="0.25s">
                            This is a bare-bones page to host misc files. It may get revamped in the future. It is not discoverable from elsewhere on the BlockScience website.
                        </p>
                    </div>
                </header>
                <div className={style.content}>

                    <div className="container">
                        <h4 className={cx(style.resourceTitle, 'wow fadeInUp')} style={{ marginBottom: '10px', marginTop: '30px' }}>“Navigating Information Infrastructure” Zine</h4>
                        <div className={style.articleLinks}>
                            <ul>
                                <File file={Introduction} title='Introduction' />
                                <File file={Ethnography} title='An Ethnography of Decentralised Information Infrastructure' />
                                <File file={TechnoReflexivity} title='Techno-reflexivity: A creative methodology for software developer un-bias' />
                                <File file={AlgorithmsAsPolicy} title='Algorithms as Policy' />
                                <File file={AutomatingOstrom} title='Automating Ostrom for Effective DAO Management' />
                                <File file={DeterringAdversarial} title='Deterring Adversarial Behavior at Scale in Gitcoin Grants' />
                                <File file={EngineeringEthics} title='Engineering Ethics in Web3' />
                                <File file={ExploringDAOs} title='Exploring DAOs as a New Kind of Institution' />
                                <File file={CAG} title='Towards Computer-Aided Governance of Gitcoin Grants' />
                                <File file={DecentralisedInfrastructure} title='The Possibilities of Ad Hoc Decentralised Digital Infrastructure' />
                                <File file={NetworkFormationGames} title='Network Formation Games' />
                                <File file={Conclusion} title='Conclusion' />
                            </ul>
                        </div>
                        <h4 className={cx(style.resourceTitle, 'wow fadeInUp')} style={{ marginBottom: '10px', marginTop: '30px' }}>Others</h4>
                        <div className={style.articleLinks}>
                            <ul>
                                <File file={CeramicEcosystemReport} title='Ceramic Ecosystem Mapping Report' />
                                <File file={ArbitrumExpert} title='Arbitrum Expert Service Provider Network Program Development' />
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}